import React from "react";
import LeftArrow from "./../assets/icons/left-arrow.png";
import { Box, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { getKeyFromText } from "../utils/Utilities";

const AdviserDocsWrapper = ({ children, pageName }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname?.split("/")?.pop()?.replaceAll("-", " ");
  const handleLinkClick = () => {
    navigate(-1);
  };
  return (
    <>
      <Box className="layout-right-container-2">
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            padding: "2rem .8rem 0 .8rem",
          }}
        >
          <Box
            sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
            my={2}
            onClick={() => handleLinkClick()}
          >
            <Box component={"img"} src={LeftArrow} width="30px"></Box>
            <Typography component="p" ml={2} fontSize="0.9rem" fontWeight={600}>
              {t(getKeyFromText(path.charAt(0).toUpperCase() + path.slice(1)))}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography
              component="p"
              fontSize="0.9rem"
              textAlign={"center"}
              fontWeight={600}
            >
              {t(getKeyFromText(pageName))}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box>{children}</Box>
    </>
  );
};

export default AdviserDocsWrapper;
